import React from 'react';
import { TIMELINE } from './data';

const KIND = {
  hack: { dot: 'bg-[#D7FF38]', row: 'bg-[#D7FF38]/35', label: '24H' },
  workshop: { dot: 'bg-[#365CFF]', row: '', label: 'Workshop' },
  hr: { dot: 'bg-[#FF6338]', row: '', label: 'Conclave' },
};

const Item = ({ time, title, kind, dur }) => {
  const k = KIND[kind];
  return (
    <li className={`relative grid sm:grid-cols-[150px_1fr] gap-1 sm:gap-6 pl-8 sm:pl-10 py-4 border-b-2 border-[#111]/10 ${k?.row || ''}`}>
      <span className={`absolute left-[7px] sm:left-[11px] top-5 w-4 h-4 border-2 border-[#111] ${k?.dot || 'bg-white'}`} aria-hidden="true" />
      <span className="text-xs sm:text-sm font-extrabold tabular-nums">{time}</span>
      <span className="text-sm sm:text-base font-medium flex flex-wrap items-center gap-2">
        {title}
        {dur && <span className="text-[10px] font-extrabold uppercase tracking-wider bg-[#111] text-[#D7FF38] px-1.5 py-0.5" data-testid="timeline-duration">{dur}</span>}
        {k && <span className="text-[10px] font-extrabold uppercase tracking-wider border-2 border-[#111] bg-white px-1.5">{k.label}</span>}
      </span>
    </li>
  );
};

export const ConvergeTimeline = () => (
  <section id="timeline" className="scroll-mt-20 border-b-2 border-[#111]" data-testid="timeline-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.25em]">[ 05 ] Timeline</p>
      <h2 className="cv-display font-extrabold uppercase leading-[0.9] mt-3 text-5xl sm:text-7xl">Two days.<br /><span className="cv-outline">Every hour.</span></h2>
      <div className="mt-6 flex flex-wrap gap-3 text-[11px] font-bold uppercase tracking-wider" data-testid="timeline-legend">
        <span className="flex items-center gap-2"><span className="w-3.5 h-3.5 bg-[#D7FF38] border-2 border-[#111]" />24-hour hackathon (1 PM 16 Nov → 1 PM 17 Nov)</span>
        <span className="flex items-center gap-2"><span className="w-3.5 h-3.5 bg-[#365CFF] border-2 border-[#111]" />Workshop</span>
        <span className="flex items-center gap-2"><span className="w-3.5 h-3.5 bg-[#FF6338] border-2 border-[#111]" />HR Conclave</span>
      </div>
      <div className="mt-10 grid lg:grid-cols-2 gap-8">
        {TIMELINE.map((d) => (
          <div key={d.day} className="bg-white border-2 border-[#111] shadow-[6px_6px_0_#111]" data-testid={`timeline-${d.day.toLowerCase().replace(' ', '-')}`}>
            <div className="flex items-baseline justify-between gap-3 bg-[#111] text-[#F5F3EB] px-5 py-4">
              <h3 className="cv-display text-3xl sm:text-4xl font-extrabold uppercase">{d.day}</h3>
              <span className="text-xs font-bold uppercase tracking-wider text-[#D7FF38]">{d.date}</span>
            </div>
            <ol className="relative">
              <span className="absolute left-[14px] sm:left-[18px] top-0 bottom-0 w-0.5 bg-[#111]" aria-hidden="true" />
              {d.items.map(([time, title, kind, dur]) => <Item key={time + title} time={time} title={title} kind={kind} dur={dur} />)}
            </ol>
          </div>
        ))}
      </div>
    </div>
  </section>
);
